import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EParamChannelTypeGlobal,
  ETimeBucketType,
  EReportingTimeWindow,
  IReportingAdvertisersChartResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import { TAdvertisersReportChartFilters, TPPRetailerId } from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingAdvertisersChartV3({
  retailerId,
  advertiserId,
  timeWindow,
  startDate,
  endDate,
  tzZone,
  aggregationType,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  channelType,
  enabled = true,
  suspense = true,
}:
  | {
      enabled?: boolean
      suspense?: boolean
    } & TAdvertisersReportChartFilters &
      TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingAdvertisersChartResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAdvertisersChart_${retailerId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate }],
    () => {
      return coreAPIV3.retailerReporting().getRetailerAdvertisersReportChart(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        timeWindow as unknown as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        aggregationType as ETimeBucketType,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status,
        channelType as EParamChannelTypeGlobal | undefined
      )
    },
    { suspense, enabled }
  )
}
